import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../analytics/pageTracker';

/** BrowserRouter içinde render edilir; her rota değişiminde sayfa görüntülemesi kaydeder. */
const PageTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
};

export default PageTracker;
